import moment from "moment";

// A code ref is stored inside model data, so nothing here touches refs that already exist. It only
// shapes the ones created from now on.

// The first two segments are load-bearing: consumers read `codeRef.split("-")[0]` as the component
// type (utils/enclosure/components.js, utils/review/buildReviewTable.js, several component lists)
// and match prefixes like "Wall-U" to tell a user-defined code from a standard one. So the
// organization marker goes on the end, where no existing reader looks.
const ORG_REF_SEGMENT = "org";

const ORG_REF_PATTERN = new RegExp(`-${ORG_REF_SEGMENT}-([A-Za-z0-9]+)$`);

// Refs used to be component type, code type and a timestamp to the hundredth of a second. Two
// people saving the same kind of code in the same tick produced the same ref, which is invisible
// while every user has their own library and silently overwrites once they share one.
const randomTail = () => Math.random().toString(36).slice(2, 8);

export const makeCodeRef = ({ componentCodeType = "", codeType = "", orgId = "" }) =>
    [componentCodeType, codeType, moment().format("YYYYMMDDHHmmssSS"), randomTail(), orgId ? `org-${orgId}` : null]
        .filter(Boolean)
        .join("-");

// An organization's codes live in their own namespace, so the same code promoted to an
// organization never shares a ref with the personal copy it was made from.
export const isOrgCodeRef = (codeRef) => typeof codeRef === "string" && ORG_REF_PATTERN.test(codeRef);

export const getOrgIdFromCodeRef = (codeRef) =>
    (typeof codeRef === "string" ? (codeRef.match(ORG_REF_PATTERN) || [])[1] : "") || "";

// The library lists personal and organization codes together. A source of "all" keeps them that
// way, "personal" drops every organization code, and an org id keeps only that organization's.
export const filterCodesBySource = (codes = {}, source = "all") => {
    if (source === "all") return codes;

    return Object.fromEntries(
        Object.entries(codes).filter(([codeRef]) =>
            source === "personal" ? !isOrgCodeRef(codeRef) : getOrgIdFromCodeRef(codeRef) === source
        )
    );
};
